const CHAT_EVENTS = {
  TYPING: "application/vnd.amazonaws.connect.event.typing",
  PARTICIPANT_JOINED:
    "application/vnd.amazonaws.connect.event.participant.joined",
  PARTICIPANT_LEFT: "application/vnd.amazonaws.connect.event.participant.left",
  TRANSFER_SUCCEEDED:
    "application/vnd.amazonaws.connect.event.transfer.succeed",
  TRANSFER_FAILED: "application/vnd.amazonaws.connect.event.transfer.failed",
  CHAT_ENDED: "application/vnd.amazonaws.connect.event.chat.ended"
};

export { CHAT_EVENTS };
